import { AfFindAgencyController } from './AfFindAgencyController';

export class AfFindAgency2Controller extends AfFindAgencyController {

}
